export default "__VITE_ASSET__usFr22e1__"